import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import { AskTicketsEffects } from './tickets.effects';
import { AskTicketsNamespace, AskTicketsReducer } from './tickets.state';

export const askTicketsStoreProvider = provideState(AskTicketsNamespace, AskTicketsReducer);
export const askTicketsEffectsProvider = provideEffects([AskTicketsEffects]);
export const provideAskHrTicketsNgrx = [askTicketsStoreProvider, askTicketsEffectsProvider];

@NgModule({
  imports: [
    StoreModule.forFeature(AskTicketsNamespace, AskTicketsReducer),
    EffectsModule.forFeature([AskTicketsEffects]),
  ],
})
export class AskHrTicketsStoreDataModule {}
